export const defaultSettings = {
	size: 300,
	ecLevel: 'M',
	quietZone: 20,
	bgColor: '#FFFFFF',
	fgColor: '#000000',
	logoImage: '',
	logoName: '',
    logoFile: null,
	logoWidth: 50,
	logoHeight: 50,
	logoOpacity: 1,
	qrStyle: 'squares',
	maintainAspectRatio: true,
	custom: false,
	removeQrCodeBehindLogo: true,
	logoTab: 'file',
	logoUrl: '',
    value: '',
    eyeRadiusStyle: 'square',
    rotation: 0,
    maxEyeRadius: 42,
    eyeRadius: {
        eyeradius_0_outer_0: 0,
        eyeradius_0_outer_1: 0,
        eyeradius_0_outer_2: 0,
        eyeradius_0_outer_3: 0,
        eyeradius_0_inner_0: 0,
        eyeradius_0_inner_1: 0,
        eyeradius_0_inner_2: 0,
        eyeradius_0_inner_3: 0,
        eyeradius_1_outer_0: 0,
        eyeradius_1_outer_1: 0,
        eyeradius_1_outer_2: 0,
        eyeradius_1_outer_3: 0,
        eyeradius_1_inner_0: 0,
        eyeradius_1_inner_1: 0,
        eyeradius_1_inner_2: 0,
        eyeradius_1_inner_3: 0,
        eyeradius_2_outer_0: 0,
        eyeradius_2_outer_1: 0,
        eyeradius_2_outer_2: 0,
        eyeradius_2_outer_3: 0,
        eyeradius_2_inner_0: 0,
        eyeradius_2_inner_1: 0,
        eyeradius_2_inner_2: 0,
        eyeradius_2_inner_3: 0,
      },
};

export const eyeRadiusCustom = (radius: number): { [key: string]: number } => {
    return {
        eyeradius_0_outer_0: radius,
        eyeradius_0_outer_1: radius,
        eyeradius_0_outer_2: radius,
        eyeradius_0_outer_3: radius,
        eyeradius_0_inner_0: radius,
        eyeradius_0_inner_1: radius,
        eyeradius_0_inner_2: radius,
        eyeradius_0_inner_3: radius,
        eyeradius_1_outer_0: radius,
        eyeradius_1_outer_1: radius,
        eyeradius_1_outer_2: radius,
        eyeradius_1_outer_3: radius,
        eyeradius_1_inner_0: radius,
        eyeradius_1_inner_1: radius,
        eyeradius_1_inner_2: radius,
        eyeradius_1_inner_3: radius,
        eyeradius_2_outer_0: radius,
        eyeradius_2_outer_1: radius,
        eyeradius_2_outer_2: radius,
        eyeradius_2_outer_3: radius,
        eyeradius_2_inner_0: radius,
        eyeradius_2_inner_1: radius,
        eyeradius_2_inner_2: radius,
        eyeradius_2_inner_3: radius,
    };
}

export const eyeRadiusSquare: { [key: string]: number } = {
    eyeradius_0_outer_0: 0,
    eyeradius_0_outer_1: 0,
    eyeradius_0_outer_2: 0,
    eyeradius_0_outer_3: 0,
    eyeradius_0_inner_0: 0,
    eyeradius_0_inner_1: 0,
    eyeradius_0_inner_2: 0,
    eyeradius_0_inner_3: 0,
    eyeradius_1_outer_0: 0,
    eyeradius_1_outer_1: 0,
    eyeradius_1_outer_2: 0,
    eyeradius_1_outer_3: 0,
    eyeradius_1_inner_0: 0,
    eyeradius_1_inner_1: 0,
    eyeradius_1_inner_2: 0,
    eyeradius_1_inner_3: 0,
    eyeradius_2_outer_0: 0,
    eyeradius_2_outer_1: 0,
    eyeradius_2_outer_2: 0,
    eyeradius_2_outer_3: 0,
    eyeradius_2_inner_0: 0,
    eyeradius_2_inner_1: 0,
    eyeradius_2_inner_2: 0,
    eyeradius_2_inner_3: 0,
}